import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const rankingTwoWayHorizontalBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'x2', type: 'number', required: true },
    { field: 'y', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'ranking-two-way-sufficient-data',
      validator: data => data.length >= 3,
      message: 'Ranking two-way horizontal bar chart requires at least 3 data points',
      suggestion: 'Provide at least 3 data points for meaningful two-way ranking comparison',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'ranking-two-way-value-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const xValues = new Set(data.map(item => item[encoding?.x as string]));
        const x2Values = new Set(data.map(item => item[encoding?.x2 as string]));
        return xValues.size >= 2 && x2Values.size >= 2;
      },
      message: 'Ranking two-way chart requires diverse values in both x and x2 fields',
      suggestion:
        'Provide varied numerical values in both x and x2 fields for effective comparison',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'ranking-two-way-meaningful-difference',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 检查x和x2之间是否有有意义的差异
        return data.some(item => {
          const xVal = Number(item[encoding?.x as string]);
          const x2Val = Number(item[encoding?.x2 as string]);
          return Math.abs(xVal - x2Val) > 0;
        });
      },
      message:
        'Ranking two-way chart works best with meaningful differences between x and x2 values',
      suggestion: 'Ensure x and x2 fields have different values to show comparison effectively',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
